import React, { Component } from 'react';
import { DropTarget } from 'react-drag-drop-container';
import { Stage, Layer, Rect } from 'react-konva';
import ReactResizeDetector from 'react-resize-detector';

import { GenericComponentCanvas } from "./componentCanvas/GenericComponentCanvas";
import { NotesComponentCanvas } from "./componentCanvas/NotesComponentCanvas";
import { ImageComponentCanvas } from "./componentCanvas/ImageComponentCanvas";
import { QrCodeComponentCanvas } from "./componentCanvas/QrCodeComponentCanvas";
import { ExceptionsComponentCanvas } from "./componentCanvas/ExceptionsComponentCanvas";
import { StopInformationComponentCanvas } from "./componentCanvas/StopInformationComponentCanvas";
import { LineInformationComponentCanvas } from "./componentCanvas/LineInformationComponentCanvas";
import { SeparatorComponentCanvas } from "./componentCanvas/SeparatorComponentCanvas";
import { DayTimesheetComponentCanvas } from "./componentCanvas/DayTimesheetComponentCanvas";
import { DayVerticalTimesheetComponentCanvas } from "./componentCanvas/DayVerticalTimesheetComponentCanvas";
import { CompactDayTimesheetComponentCanvas } from "./componentCanvas/CompactDayTimesheetComponentCanvas";
import { VerticalDayTimesheetComponentCanvas } from "./componentCanvas/VerticalDayTimesheetComponentCanvas";
import { VerticalTabularDayTimesheetComponentCanvas } from './componentCanvas/VerticalTabularDayTimesheetComponentCanvas';
import { VerticalComposedDayTimesheetComponentCanvas } from './componentCanvas/VerticalComposedDayTimesheetComponentCanvas';
import { HorizontalTabularDayTimesheetComponentCanvas } from './componentCanvas/HorizontalTabularDayTimesheetComponentCanvas';
import { VerticalStopsListComponentCanvas } from "./componentCanvas/VerticalStopsListComponentCanvas";
import { HorizontalStopsListComponentCanvas } from "./componentCanvas/HorizontalStopsListComponentCanvas";
import { SmsBusComponentCanvas } from "./componentCanvas/SmsBusComponentCanvas";
import { PassingIntervalsComponentCanvas } from './componentCanvas/PassingIntervalsComponentCanvas';
import { SchematicMapComponentCanvas } from './componentCanvas/SchematicMapComponentCanvas';

export class LayoutCanvas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            componentsCanvas: {
                notes: NotesComponentCanvas,
                image: ImageComponentCanvas,
                qrCode: QrCodeComponentCanvas,
                exceptions: ExceptionsComponentCanvas,
                stopInformation: StopInformationComponentCanvas,
                separator: SeparatorComponentCanvas,
                lineInformation: LineInformationComponentCanvas,
                dayTimesheet: DayTimesheetComponentCanvas,
                dayVerticalTimesheet: DayVerticalTimesheetComponentCanvas,
                verticalStopsList: VerticalStopsListComponentCanvas,
                horizontalStopsList: HorizontalStopsListComponentCanvas,
                smsBus: SmsBusComponentCanvas,
                compactDayTimesheet: CompactDayTimesheetComponentCanvas,
                verticalDayTimesheet: VerticalDayTimesheetComponentCanvas,
                verticalComposedDayTimesheet: VerticalComposedDayTimesheetComponentCanvas,
                verticalTabularDayTimesheet: VerticalTabularDayTimesheetComponentCanvas,
                horizontalTabularDayTimesheet: HorizontalTabularDayTimesheetComponentCanvas,
                passingIntervals: PassingIntervalsComponentCanvas,
                schematicMap: SchematicMapComponentCanvas
            }
        }
    }

    render() {
        const { layout, selectedComponentInternalId, selectedGeometryIndex, canvas, onResize, onDragEnter, onDragLeave, onHitLayout, onMoveExistingComponent, onComponentClick } = this.props;
        const { componentsCanvas } = this.state;

        const components = [...layout.components].sort(
            (a, b) => a.positionZ - b.positionZ
        );

        const geometries = components.flatMap(component =>
            component.geometries.map((geometry, geometryIndex) => ({
                component,
                geometry,
                geometryIndex
            }))
        );

        const componentsElements = geometries.map((entry) => {
            const { component, geometry, geometryIndex } = entry;

            const key = `geo-${component.internalId}-${geometryIndex}-${geometry.drawPositionX}-${geometry.drawPositionY}`;
            const rendererName = component.type[0].toLowerCase() + component.type.slice(1);

            const ComponentElement = (componentsCanvas && componentsCanvas[rendererName])
                ? componentsCanvas[rendererName]
                : GenericComponentCanvas;

            const isComponentSelected = selectedComponentInternalId === component.internalId;

            return (
                <ComponentElement
                    key={key}
                    component={component}
                    geometry={geometry}
                    geometryIndex={geometryIndex}
                    isSelected={isComponentSelected}
                    selectedGeometryIndex={selectedGeometryIndex}
                    dimentionsRatio={canvas.dimentionsRatio}
                    draggable={true}
                    onDragEnd={(e) => onMoveExistingComponent(e, component, geometryIndex)}
                    onComponentClick={onComponentClick} />
            );
        });

        return (
            <ReactResizeDetector handleWidth onResize={onResize}>
                <div style={{ textAlign: "-webkit-center" }}>
                    <div id="layout">
                        <DropTarget
                            targetKey="layoutBuilder"
                            onDragEnter={onDragEnter}
                            onDragLeave={onDragLeave}
                            onHit={onHitLayout}>
                            <Stage
                                width={canvas.width + 10}
                                height={canvas.height + 10}
                                style={{ cursor: "pointer" }}>
                                <Layer>
                                    <Rect
                                        x={5}
                                        y={5}
                                        width={canvas.width}
                                        height={canvas.height}
                                        fill="white"
                                        shadowBlur={5} />
                                    {componentsElements}
                                </Layer>
                            </Stage>
                        </DropTarget>
                    </div>
                </div>
            </ReactResizeDetector>
        );
    }
}
